<template>
    <div class="release">
        <header>
            <div class="header">
                <h2>资产管理</h2>
            </div>
            <div class="line"></div>
            <div class="input_wrapper">
                <div class="input_box">
                    <input type="text" v-model="queryParams.modelName" @change="query();" placeholder="请输入资产名称" />
                    <van-icon name="search" color="#969696" size="20" />
                </div>
                <div class="switch_btn">
                    <span @click="changeListStyle('list')" :class="{ active: currentListStyle == 'list' }"><van-icon
                            name="list-switch" size="20rem" /></span>
                    <span @click="changeListStyle('grid')" :class="{ active: currentListStyle == 'grid' }"><van-icon
                            name="list-switching" size="20rem" /></span>
                </div>
            </div>

            <div class="tabs">
                <span @click="queryParams.assetSource = ''; query();"
                    :class="{ active: !queryParams.assetSource }">全部</span>
                <span @click="queryParams.assetSource = 1; query();"
                    :class="{ active: queryParams.assetSource == 1 }">上传</span>
                <span @click="queryParams.assetSource = 2; query();"
                    :class="{ active: queryParams.assetSource == 2 }">购买</span>
            </div>
        </header>
        <div class="query_params">
            <span @click="() => categoryPickerRef.openPicker()">{{ queryParams.platformCate ?
                queryParams.platformCateName : '平台分类' }} <van-icon name="arrow-down" /></span>
            <!-- <span @click="() => assetsResourcesPickerRef.openPicker()">{{ queryParams.assetSource ?
                queryParams.asset资产来源' }}资产来源' }} <van-icon name="arrow-down" /></span> -->
            <span @click="() => assetsTypePickerRef.openPicker()">{{ queryParams.assetType ?
                queryParams.assetTypeName : '资产类型' }} <van-icon name="arrow-down" /></span>
            <span @click="() => auditStatusPickerRef.openPicker()">{{ queryParams.auditStatus ?
                queryParams.auditStatusName : '发布状态' }} <van-icon name="arrow-down" /></span>
            <span @click="() => uploadStatusPickerRef.openPicker()">{{ queryParams.uploadStatus ?
                queryParams.uploadStatusName : '上传状态' }} <van-icon name="arrow-down" /></span>
            <span @click="() => timeRangePickerRef.openPicker()">时间 <van-icon name="arrow-down" /></span>
        </div>
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
            v-if="currentListStyle == 'list'">
            <ul class="list">
                <li v-for="item in list" :key="item.id">
                    <div class="name">
                        <p>{{ item.modelName }}</p>
                        <router-link :to="{ 'path': '/assets-detail', 'query': { id: item.id } }">查看</router-link>
                    </div>
                    <div class="line"></div>
                    <div class="content">
                        <img :src="item.modelCoverUrl ? item.modelCoverUrl.split(';')[0] : ''" alt="">
                        <div>
                            <p>大小 {{ item.modelSizeWithUnit }}</p>
                            <p>格式 {{ item.modelFormat }}</p>
                            <p>类型 {{ item.assetType == 1 ? '模型' : '作品' }}</p>
                        </div>
                        <div>
                            <p>平台分类 {{ item.platformCateName }}</p>
                            <p>资产来源 {{ item.assetSource == 1 ? '上传' : '购买' }}</p>
                            <p>上传状态 {{ ['上传中', '上传失败', '上传成功'][item.uploadStatus] }}</p>
                        </div>
                    </div>
                    <p class="time">创建时间 {{ timeStampFormat(item.createTime) || '-' }}</p>
                    <div class="status"
                        :style="{ background: ['#A1BAC4', '#FF8D1A', '#FF5733', '#00BAAD', '#00BAAD', '#A1BAC4'][item.auditStatus] }">
                        {{ ['未发布', '待审核', '审核失败', '审核成功', '已发布', '已下架'][item.auditStatus] }}</div>
                </li>
            </ul>
        </van-list>

        <van-list v-else>
            <ul class="grid_list">
                <li v-for="item in list" :key="item.id">
                    <div class="assets_card">
                        <img @click="jumpToDetail(item)"
                            :src="item.modelCoverUrl ? item.modelCoverUrl.split(';')[0] : ''" alt=""
                            :style="{ backgroundImage: 'url(' + (item.modelBgImage || 'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background01.png') + ')' }">
                        <h6>{{ item.modelName }} {{ item.modelFormat || '' }}
                            <van-icon :name="require('@/assets/imgs/icon60.png')" @click="toAction(item)"
                                size="18rem" />
                        </h6>
                        <span class="icon1" v-if="item.assetSource">
                            <img src="@/assets/imgs/icon56.png" v-if="item.assetSource == 1" alt="">
                            <img src="@/assets/imgs/icon55.png" v-else alt="">
                        </span>
                        <span class="icon2"
                            :style="{ background: ['#A1BAC4', '#FF8D1A', '#FF5733', '#00BAAD', '#00BAAD', '#A1BAC4'][item.auditStatus] }"
                            v-if="item.auditStatus !== undefined">
                            {{ ['未发布', '待审核', '审核驳回', '审核成功', '已发布', '已下架', '-'][item.auditStatus] }}
                        </span>
                    </div>
                </li>
            </ul>
        </van-list>
    </div>


    <category-picker ref="categoryPickerRef"
        @confirm="d => { queryParams.platformCate = d[1].id; queryParams.platformCateName = d[1].name; query() }" />
    <assets-type-picker ref="assetsTypePickerRef"
        @confirm="d => { queryParams.assetType = d[0].id; queryParams.assetTypeName = d[0].name; query() }" />
    <!-- <assets-resources-picker ref="assetsResourcesPickerRef"
        @confirm="d => { queryParams.assetSource = d[0].id; queryParams.assetSourceName = d[0].name; query() }" /> -->
    <time-range-picker ref="timeRangePickerRef"
        @confirm="d => { queryParams.createTime = d.startDate.getTime() + ',' + d.endDate.getTime(); query() }" />
    <audit-status-picker ref="auditStatusPickerRef"
        @confirm="d => { queryParams.auditStatus = d[0].id; queryParams.auditStatusName = d[0].name; query() }" />
    <upload-status-picker ref="uploadStatusPickerRef"
        @confirm="d => { queryParams.uploadStatus = d[0].id; queryParams.uploadStatusName = d[0].name; query() }" />

    <van-action-sheet v-model:show="showActionSheet" :actions="actions" @select="onSelect" />
    <share-dialog ref="shareDialogRef" />
</template>

<script setup>
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { timeStampFormat } from '@/utils/util'
import categoryPicker from '../../components/categoryPicker.vue'
import assetsTypePicker from '../../components/assetsTypePicker.vue'
import assetsResourcesPicker from '../../components/assetsResourcesPicker.vue'
import timeRangePicker from '../../components/timeRangePicker.vue'
import auditStatusPicker from '../../components/auditStatusPicker.vue'
import uploadStatusPicker from '../../components/uploadStatusPicker.vue'
import shareDialog from '@/views/front/components/ShareDialog.vue'

// const showCategoryPicker = ref(false), showAssetPicker = ref(false), showAssetTypePicker = ref(false), showTimePicker = ref(false)
const categoryPickerRef = ref(null)
const assetsTypePickerRef = ref(null)
const assetsResourcesPickerRef = ref(null)
const timeRangePickerRef = ref(null)
const auditStatusPickerRef = ref(null)
const uploadStatusPickerRef = ref(null)
const shareDialogRef = ref(null)

const router = useRouter()
const store = useStore()
const queryParams = reactive({
    createTime: null,
    platformCate: null,  //平台分类
    platformCateName: null, //平台分类名称
    assetType: '',    //资产类型(1-模型;2-作品)
    assetTypeName: null, //资产类型名称
    assetSource: '', //资产来源(1-上传;2-购买)
    assetSourceName: null, //资产来源名称
    modelName: null,  //资产名称
    uploadStatus: '', //上传状态(0-转换中;2-上传成功;1-转换失败)
    uploadStatusName: null, //上传状态名称
    auditStatus: '', //发布状态(0-未发布;1-待审核;2-审核失败;3-审核成功;4-已发布;5-已下架)
    auditStatusName: null, //审核状态名称
})
const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
    total: 0
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const fetchList = () => {
    loading.value = true
    http.get('/app-api/model/user-asset/page', {
        params: Object.assign({}, queryParams, pagination)
    }).then(res => {
        loading.value = false
        finished.value = res.list.length < pagination.pageSize
        pagination.total = res.total
        list.value = [...list.value, ...res.list]
    })
}
const onLoad = () => {
    pagination.pageNo++
    fetchList()
}
const query = () => {
    pagination.pageNo = 1
    list.value = []
    finished.value = false
    fetchList()
}
onMounted(() => {
    fetchList()
})

const currentListStyle = ref('grid')
const changeListStyle = (style) => {
    currentListStyle.value = style
}

function jumpToDetail(item) {
    router.push({ path: '/workbench/assets-lib/detail', query: { id: item.modelId } })
    window.scrollTo(0, 0)
}

const showActionSheet = ref(false)
const actions = ref([
    { name: '下载' },
    { name: '分享' },
    { name: '下架' }
])
const onSelect = (item) => {
    switch (item.name) {
        case '下载':
            currentActionTarget.downloadUrl && window.open(currentActionTarget.downloadUrl)
            break;
        case '分享':
            shareDialogRef.value.show(location.origin + '/assets-detail?id=' + currentActionTarget.id)
            break;
        case '下架':
            http.get('app-api/model/asset-release/off?modelId=' + currentActionTarget.id).then(res => {
                fetchList()
            })
            break;
        default:
            break;
    }
    showActionSheet.value = false
}
var currentActionTarget
const toAction = (item) => {
    currentActionTarget = item
    showActionSheet.value = true
}
</script>

<style lang="scss" scoped>
@use '../common.scss';

.release {
    background-color: #F6F6F6;
    min-height: 100vh;

    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }

        .input_wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .input_box {}

            .switch_btn {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-left: 10rem;

                span {
                    display: inline-block;
                    font-size: 14rem;
                    text-align: center;
                    width: 39rem;
                    height: 32rem;
                    line-height: 32rem;
                    color: #383838;
                    text-align: center;
                    border: 1px solid #A6A6A6;
                }

                span:first-child {
                    border-radius: 5rem 0 0 5rem;
                }

                span:last-child {
                    border-radius: 0 5rem 5rem 0;
                }

                .active {
                    background-color: #000000;
                    color: #FFF;
                }
            }
        }

    }

    .list {
        padding-bottom: 50rem;

        li {
            background-color: #fff;
            width: 400rem;
            margin: 10rem auto;
            padding: 15rem;
            border-radius: 4rem;
            position: relative;

            .name {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14rem;

                a {
                    color: #0071BB;
                }
            }

            .line {
                width: 100%;
                height: 1rem;
                background-color: #F6F6F6;
                margin: 10rem 0;
            }

            .content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                img {
                    width: 65rem;
                    height: 54rem;
                    object-fit: cover;
                }

                div {
                    width: 30%;

                    p {
                        font-size: 12rem;
                        white-space: nowrap;
                        margin-bottom: 10rem;
                        color: #717171;
                    }
                }
            }

            .time {
                font-size: 12rem;
                color: #717171;
                margin-top: 10rem;
                text-align: right;
            }

            .status {
                width: 68rem;
                height: 20rem;
                line-height: 20rem;
                text-align: center;
                color: #FFF;
                font-size: 12rem;
                position: absolute;
                bottom: 15rem;
                left: 15rem;
            }
        }
    }

    .grid_list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0 15rem;
        gap: 15rem;

        li {
            width: calc(50% - 7.5rem);
        }

        .assets_card {
            width: 100%;
            flex-shrink: 0;
            position: relative;
            padding-bottom: 10rem;

            >img {
                width: 100%;
                height: 140rem;
                object-fit: cover;
                background-size: cover;
            }

            h6 {
                padding: 5rem;
                height: 40rem;
                font-weight: normal;
                font-size: 14rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .icon1 {
                position: absolute;
                top: 8rem;
                left: 8rem;
                width: 24rem;
                height: 24rem;
                display: block;

                img {
                    width: 56rem;
                    height: 20rem;
                }
            }

            .icon2 {
                position: absolute;
                top: 8rem;
                right: 8rem;
                width: 68rem;
                height: 20rem;
                display: block;
                font-size: 12rem;
                text-align: center;
                background-color: #00BAAD;
                color: #FFF;
            }
        }
    }
}
</style>